/**
 * Mobile-only ExploreHeader secondary row visibility policy.
 *
 * Hide "Let's plan your next adventure" + "Import Travel Inspo" on pages that
 * already have dense hero/action controls directly beneath the fixed header.
 */
export function shouldShowMobileHeaderJourneyCta(pathname: string): boolean {
    if (pathname === '/results') {
        return false;
    }

    if (pathname === '/performance' || pathname.startsWith('/performance/')) {
        return false;
    }

    if (pathname === '/my-travel' || pathname.startsWith('/my-travel/')) {
        return false;
    }

    if (pathname === '/saved' || pathname.startsWith('/saved/')) {
        return false;
    }

    if (
        pathname === '/profile' ||
        pathname.startsWith('/profile/') ||
        pathname.startsWith('/storefront/') ||
        pathname.startsWith('/book/')
    ) {
        return false;
    }

    return !/^\/(list|itinerary|place)(\/|$)/.test(pathname);
}


/**
 * Window event that opens ExploreHeader's mobile "More" drawer from outside the
 * header — used on the user's own profile, where the top bar is hidden and the
 * profile hero renders its own menu button.
 */
export const OPEN_MOBILE_MORE_MENU_EVENT = 'gt:open-mobile-more-menu';

/**
 * True for the signed-in user's own profile route under any of the three
 * aliases: `/profile`, `/profile/<id>`, `/storefront/<id>`, or `/book/<id>`.
 * The `<id>` can be either the Mongo `_id` or the user's handle; callers that
 * want "own by handle" too should pass the handle as `userId`.
 */
export function isOwnProfilePath(pathname: string, userId: string | undefined): boolean {
    if (!userId) return false;
    if (pathname === '/profile') return true;
    return (
        pathname === `/profile/${userId}` ||
        pathname === `/storefront/${userId}` ||
        pathname === `/book/${userId}`
    );
}
